import { IconProps } from "@/data/types"

export default function CinemaIcon({
  width = 32,
  height = 32,
  color = "#000000",
  className,
}: IconProps) {
  return (
    <div className={className}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        stroke={color}
        strokeMiterlimit="10"
        strokeWidth="0.72"
      >
        <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
        <g
          id="SVGRepo_tracerCarrier"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></g>
        <g id="SVGRepo_iconCarrier">
          <circle cx="12" cy="16.8" r="1.91"></circle>
          <path d="M9.13,23.5V21.59A2.87,2.87,0,0,1,12,18.72h0a2.87,2.87,0,0,1,2.87,2.87V23.5"></path>
          <circle cx="6.26" cy="16.8" r="1.91"></circle>
          <path d="M3.39,23.5V21.59a2.87,2.87,0,0,1,2.87-2.87h0a2.86,2.86,0,0,1,2.87,2.87V23.5"></path>
          <circle cx="17.74" cy="16.8" r="1.91"></circle>
          <path d="M14.87,23.5V21.59a2.86,2.86,0,0,1,2.87-2.87h0a2.87,2.87,0,0,1,2.87,2.87V23.5"></path>
          <path d="M1.48,7.24h0V1.5H12l-.11.17A12.52,12.52,0,0,1,1.48,7.24Z"></path>
          <path d="M6.86,15A23.3,23.3,0,0,0,5.7,11.89,12.79,12.79,0,0,0,1.48,7.24V23.5"></path>
          <path d="M22.52,23.5V7.24a12.79,12.79,0,0,0-4.22,4.65A12.44,12.44,0,0,0,17.14,15"></path>
          <path d="M22.52,7.24h0V1.5H12l.11.17A12.52,12.52,0,0,0,22.52,7.24Z"></path>
        </g>
      </svg>
    </div>
  )
}
